<template>
  <div class="mealplan">
    <div class="mealplan__info" v-for="(meal, meal_index) in meals" :key="_uid+'_mealplan_'+meal_index">
      <vb-icon class="mealplan__icon" :name="get_mealplan(meal).icon" :color="sass('success')" :size="16" />
      <span>{{ get_mealplan(meal).name }}</span>
      <vb-icon
        class="mealplan__icon mealplan__icon--info"
        v-if="get_mealplan(meal).tooltip !== ''"
        :name="'info'"
        :color="sass('gray-500')"
        :size="14"
        v-b-popover.hover.top="get_mealplan(meal).tooltip"
      />
    </div>
  </div>
</template>

<script>
import { get_mealplan } from "@bookingv3/resources"

export default {
  name: 'mealplan',

  components: {
  },

  props: {
    meals: Array,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_mealplan = get_mealplan
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .mealplan {
    line-height: normal;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &__info {
      display: flex;
      align-items: flex-start;
      font-size: $font-size-md;
      color: $success;
      margin-right: 10px;
    }

    &__icon {
      display: none;

      @include media-breakpoint-up(sm){
        display: block;
        margin-right: 5px;
      }

      &--info {
        margin: 2px 0 0 5px;
      }
    }
  }

</style>